import { CustomNotification } from 'common/components';

import { useMutation, useIsMutating } from '@tanstack/react-query';
import { editUserMicrosoftEmail } from 'services/user';

const EDIT_MICROSOFT_ENTRA_ID_KEY = ['user-profile', 'edit-microsoft-entra-id'];

export const useEditMicrosoftEntraID = () => {
  const editMicrosoftEntraIDMutation = useMutation({
    mutationFn: editUserMicrosoftEmail,
    mutationKey: EDIT_MICROSOFT_ENTRA_ID_KEY,
    onSuccess: (result) => {
      if (result?.isSuccess) {
        CustomNotification.success('Change Microsoft email successfully.');
      } else {
        CustomNotification.error(result?.message || 'Something went wrong!');
      }
    },
    onError: () => {
      CustomNotification.error('Something went wrong!');
    },
  });
  const loading = useIsMutating({
    mutationKey: EDIT_MICROSOFT_ENTRA_ID_KEY,
  });
  return {
    editMicrosoftEntraIDMutation,
    loading,
  };
};
